import { Component, OnInit, Input, AfterContentInit } from '@angular/core';
import 'rxjs/Rx';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Subscription } from "rxjs/Subscription";
import { LocalStorageService } from "angular-2-local-storage";
import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';
import { SearchTableState } from "../search-table-state";
import { Column } from "../column";
import { AppState } from "../../../app.service";
import { ProgrammeService } from "../../../services/DataServices/programme.service";
import { PageStateService } from "../page-state.service";
import { TransactionLogService } from "./transaction-log-management.service";
import { AlertService } from "../../../services";
import { BaseTableComponent } from "../base-table.component";
import * as FileSaver from "file-saver";
import { PermissionService } from "../../../services/SecurityServices/permission.service";

@Component({
    selector: 'transaction-log-management-table',
    template: require('./transaction-log-management-table.html'),
    providers: [TransactionLogService, LocalStorageService],
    styles: [require('../table.css'), require('./transaction-log-management-table.css')]
})
export class TransactionLogManagementTableComponent extends BaseTableComponent implements OnInit {

    @Input() mobileNumber: string = '';
    @Input() loyaltyTransactionLogId: string ='';
    @Input() sortColumn: string = '';
    @Input() sortOrder: string = '';
    @Input() toDate: Date = null;
    @Input() fromDate: Date = null;
    @Input() refreshTableState: boolean = false;

    private logs = [];
    private sites = [];
    private site = null;
    private searchTableState: SearchTableState;
    private columns: Array<Column>;
    private busy: Subscription;
    private queryParamsSub: any;
    private showFilter: boolean = false;
    private static lastRefreshed: string = 'transaction-log-last-refreshed';
    private disableExportToExcel: boolean = false;
    private displayFilter: boolean = true;
    private dateFormat: string = 'yyyy-mm-dd';
    private datePickerOptions: IMyDpOptions = {
        height: '30px',
        dateFormat: this.dateFormat
    };
    public toDateInit: { date: IMyDate };
    public fromDateInit: { date: IMyDate };

    constructor(private appState: AppState,
        private alertService: AlertService,
        private transactionLogService: TransactionLogService,
        private route: ActivatedRoute,
        private programmeService: ProgrammeService,
        private pageStateService: PageStateService,
        private localStorageService: LocalStorageService,
        private permissionService: PermissionService
    ) {
        super(localStorageService, transactionLogService.searchTableState);
        this.setColumns();
    }

    public goTo(value: number): void {
        if (value <= this.searchTableState.pageCount()) {
            this.searchTableState.pageChange(value);
            this.updateTable();
        }
    }

    ngAfterContentInit() {
        let self: TransactionLogManagementTableComponent = this;
        this.disableExportToExcel = !this.permissionService.userHasPermission('TransactionLogs_ExportExcel');
        if (this.refreshTableState) {
            this.transactionLogService.refreshTableState();
        }
        this.searchTableState = this.transactionLogService.searchTableState;
        this.searchTableState.mobileNumber = this.mobileNumber;
        this.searchTableState.loyaltyTransactionLogId = this.loyaltyTransactionLogId;
        this.searchTableState.currentPage = this.pageStateService.currentTransactionLogPage;
        this.setPageSize('transaction-log-page-size');
        this.blankPage();
        this.setLastRefreshed(TransactionLogManagementTableComponent.lastRefreshed);
        this.queryParamsSub = this.route.paramMap.subscribe((params: ParamMap) => {
            if (!self.searchTableState.mobileNumber) {
                self.searchTableState.mobileNumber = params['params']['mobileNumber'] || null;
            }

            if (!self.searchTableState.loyaltyTransactionLogId) {
                self.searchTableState.loyaltyTransactionLogId = params['params']['loyaltyTransactionLogId'] || null;
            }

            self.searchTableState.toDate = new Date(self.toDate);
            self.searchTableState.fromDate = new Date(self.fromDate);

            if (self.searchTableState.toDate) {
                if (self.searchTableState.toDate.getFullYear() == 1970) {
                    self.searchTableState.toDate = new Date();
                }

                self.toDateInit = {
                    date:
                    {
                        year: self.searchTableState.toDate.getFullYear(),
                        month: self.searchTableState.toDate.getMonth() + 1,
                        day: self.searchTableState.toDate.getDate()
                    }
                };
            }

            if (self.searchTableState.fromDate) {
                if (self.searchTableState.fromDate.getFullYear() == 1970) {
                    self.searchTableState.fromDate = new Date(1999, 1, 1);
                }

                self.fromDateInit = {
                        date:
                        {
                            year: self.searchTableState.fromDate.getFullYear(),
                            month: self.searchTableState.fromDate.getMonth() + 1,
                            day: self.searchTableState.fromDate.getDate()
                        }
                    };
            }

            if (this.sortColumn) {
                this.searchTableState.propertyName = this.sortColumn;
                this.searchTableState.sortOrder = this.sortOrder || 'DESC';
            }

            self.updateTable();
        });

        if (!this.route.snapshot.url.join('/').includes("transaction-log-management")) {
            self.displayFilter = false;
        }
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.pageStateService.currentTransactionLogPage = this.searchTableState.currentPage;
        this.queryParamsSub.unsubscribe();
    }

    private setColumns() {
        this.columns = new Array<Column>();
        this.columns.push(new Column('Mobile Number', 'MobileNumber'));
        this.columns.push(new Column('Date Created', 'CreateDateUTC'));
        this.columns.push(new Column('Action', 'TransactionTypeId'));
        this.columns.push(new Column('Loyalty Log ID', 'LoyaltyTransactionLogId'));
        this.columns.push(new Column('Location', 'SiteName'));
        this.columns.push(new Column('Rewards Balance', 'RewardsValue'));
        this.columns.push(new Column('Points Balance', 'PointsValue'));
        this.columns.push(new Column('Rewards Accrued', 'RewardsCount'));
        this.columns.push(new Column('Points Accrued', 'PointsCount'));
        this.columns.push(new Column('Modify User', 'modifyUserName'));
        this.columns.push(new Column('Voucher Code', 'VoucherInstanceId'));
    }

    private blankPage() {
        this.logs = new Array<any>();
        for (let i: number = 0; i < this.searchTableState.itemsPerPage; i++) {
            this.logs.push({});
        }
    }

    private exportExcel(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: TransactionLogManagementTableComponent = this;
        this.transactionLogService.exportExcel().subscribe(blob => {
            self.searchTableState.updating = false;
            if (!blob) {
                return;
            }
            var fileName = 'TransactionLog_' + this.searchTableState.lastRefreshed + '.xlsx';
            FileSaver.saveAs(blob, fileName);
            self.alertService.success('File generated successfully.');
        }, error =>  self.searchTableState.updating = false);
    }

    private filterTable(): void {
        if (this.searchTableState.fromDate && this.searchTableState.toDate && this.searchTableState.fromDate.getTime() > this.searchTableState.toDate.getTime()) {
            this.alertService.error('From Date cannot be more than To Date');
            return;
        }
        this.updateTable();
    }

    private updateTable(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        if (this.site !== null) {
            this.searchTableState.siteName = this.site.SiteName;
        }
        let self: TransactionLogManagementTableComponent = this;
        this.busy = this.transactionLogService.searchTransactionLogs().
            subscribe(
            data => {
                self.logs = data;
                console.log(data);
                self.searchTableState.totalItems = parseInt(data.length ? data[0].Total : 0);
                if (self.sites.length == 0) {
                    self.programmeService.getLoyaltySites().subscribe(data => self.sites = data);
                }
                self.searchTableState.updating = false;
            },
            error => self.searchTableState.updating = false);
    }

    private listFormatter(data: any): string {
        return data.SiteName;
    }

    private refreshTable() {
        if (this.searchTableState.updating) {
            return;
        }
        this.updateLastRefreshed(TransactionLogManagementTableComponent.lastRefreshed);
        this.updateTable();
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/transaction-log/transaction-log-management-table.component.ts